import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["coin-wrapper", `coins-${_ctx.coins.length}`])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coins, (c, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "coin-unit",
        key: i
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["coin", c]),
          style: _normalizeStyle({ animationDelay: `${i * 0.08}s` })
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "coin-face coin-heads" }, [
            _createElementVNode("span", { class: "coin-symbol" }, "₿")
          ], -1),
          _createElementVNode("div", { class: "coin-face coin-tails" }, [
            _createElementVNode("span", { class: "coin-symbol tails-symbol" }, "₿")
          ], -1)
        ]))], 6),
        _createElementVNode("div", {
          class: _normalizeClass(["coin-shadow", c])
        }, null, 2)
      ]))
    }), 128))
  ], 2))
}